<template>
	<div class="field">
		<label :for="fieldname"><span v-html="descriptionReformated"></span> <span v-if="isRequired" class="req" tabindex="-1">*</span></label>
		<div v-for="option in metaOptionsList" :key="option.id" class="field" >
			<custom-checkbox
			:fieldname="fieldname + '_' + option.id"
			inputid="metaMultipleChoice"
			:id="option.id"
			special-style="vcheck"
			v-model="checked"
			class="col2"
			:isRequired="false"
			@change="handleSelect(option.id)"
			>
			<template v-slot:msg>
				{{option.description}}
			</template>
		</custom-checkbox>
	</div>
</div>

</template>

<!-- ================================================================================== -->

<script>
	import FormFields from "../mixins/FormFields";
	import config from "../config";
	import CustomCheckbox from "@/components/CustomCheckbox.vue";
	import { customLog } from "../js/customlog.js";
	const log = (str, type) => { if ( config.isAdminNavAllowed ){ customLog(str, type); }}; 


	export default {
		name:"MultipleChoiceMeta",
		mixins: [
			customLog,
			FormFields,
		],
		components: {
			CustomCheckbox
		},
		props: {
			specialStyle: {
				type: String,
				required: true,
				validator : function(value){
					return ["default", "boldborder", "fullbg", "cross", "vcheck"].includes(value);
				}
			},
			dataSource: {
				type: String,
				required: true,
			},
			caractersBeforeOpenList : {
				type: Number,
				required: false,
				default: 3
			},
			autocomplete: {
				type: Boolean,
				required: true,
			},
			isDisabled: {
				type: Boolean,
				required: false,
				default: false,
			}
		},
		data(){
			return {
				isFocused: false,
				selectedOptions: [],
				metaData: [{
					leadmanagementmetadata: {
						description: "",
						leadmanagementmetadatavalue: []
					}
				}],
				optionsFullList: [],
				displayedInTheField: null,
				config: config,
			}
		},
		computed: {
			checked: {
				get(checkboxId) {
					return this.selectedOptions.includes(checkboxId);
				},
				set(newVal) {
					this.$emit('update:modelValue', this.selectedOptions);
					this.$emit('runCheck', {fieldname: this.fieldname, valid: Boolean(newVal)});
				}
			},
			descriptionReformated(){
				/* In case description is not there yet */
				let desc = "";
				/* If there is a description */
				if (this.metaData.description) {
					desc = this.metaData.description;
				}
				/* Only in french */
				if ( this.$i18n.locale.slice(0,2) === 'fr' ){
					/* remove possible space before "?" and then introduce a unbreakable space in front of any "?" */
					desc = desc.replace(/ ([?!:;])/g, "&nbsp;$1");
				}			
				return desc;
			},

			textInField: {
				get(){
					return this.displayedInTheField;
				},
				set(newVal){
					this.displayedInTheField = newVal;
				}
			},

			metaOptionsList(){
				let list = this.metaData.leadmanagementmetadatavalue;
				if(typeof list !== "undefined") {
					for (let item of list){
						item.description = item.description.trim();
					}
				} else {
					return [];
				}
				return list;
			},
		},
		methods: {

			isThisFieldValid(){
				/* What is a valid answer ? An answer that is exactly in the list */
				let validOptionsList = [];
				for(let item in this.optionsFullList){			
					validOptionsList.push(this.optionsFullList[item].description.trim().toLowerCase());
				}
				return validOptionsList.includes(this.displayedInTheField.trim().toLowerCase());
			},

			sendDataToForm(id){
				log(`SelectMeta transmitting id ${id} to parent`, 'low');
				this.$emit('update:modelValue', id);
			},

			sendValidityOfTheFieldToTheForm(bool){
				this.$emit('runCheck', {fieldname: this.fieldname, valid: bool});
			},

			whatToDoInCaseFieldIsValidated(id){
				log("Validation return true", 'success');
				this.sendDataToForm(id);
				this.giveSuccess();
				this.sendValidityOfTheFieldToTheForm(true);
			},

			whatToDoInCaseFieldIsNotValidated(){
				log("Validation return false", 'warning');
				this.giveError();
				this.errorMessage = this.$t('inputsTexts.dropdown.missingData');
				this.sendValidityOfTheFieldToTheForm(false);
			},

			runValidationProcess(id){
				this.removeSuccessOrError();

				/* If the field is empty, two possibilities */
				if(id === undefined){
					if(this.isRequired){
						this.whatToDoInCaseFieldIsNotValidated()
					}
					if(!this.isRequired){
						this.sendValidityOfTheFieldToTheForm(false);
					}
				}
				/* If the field is not empty */
				if(id && id.toString().length >= 0){

					this.isThisFieldValid() ? this.whatToDoInCaseFieldIsValidated(id) : this.whatToDoInCaseFieldIsNotValidated();
				}
			},

			apiForDropdownIsSuccessful(data){
				log("Data gathered from API", 'low');
				log(data);
				this.metaData = data;
				this.optionsFullList = this.metaOptionsList;
			},

			apiForDropdownHasFailed(error){
				log("apiForDropdownHasFailed", 'alert');
				log(error);
				if(error.response.status === 503){
					this.setNotLoading();
					this.$emit('maintenanceDetected');
				}else{
					log("Cannot get list from API", 'red');
				}
			},

			requestNewListFromAPI(){
				// this.optionsList = [{id:0, description: "Lorem ipsum"}];
				log("multiple choice list requested from Api", 'low');
				this.setLoading();
				this.axios.get(`/dropdown/${config.idlead}/metadata/${this.dataSource}`) 
				.then(resp => {
					this.apiForDropdownIsSuccessful(resp.data);
				})
				.catch(error => {
					this.apiForDropdownHasFailed(error);
				})
				.then(()=>{
					log(`List from API are put in place in ${this.fieldname}.`, 'low');
				});
				this.setNotLoading();
			},

			handleSelect(checkboxId, id) {
				log(`Handle ID: ${id}`, 'low');
				if (this.selectedOptions.includes(checkboxId)) {
					const index = this.selectedOptions.indexOf(checkboxId);
					if (index !== -1) {
						this.selectedOptions.splice(index, 1);
					}
				} else {
					this.selectedOptions.push(checkboxId)
				}
				log(this.selectedOptions);
				if(this.selectedOptions.length !== 0 || this.selectedOptions !== undefined || this.selectedOptions !== null){
					this.sendDataToForm(this.selectedOptions);
					this.giveSuccess();
					this.sendValidityOfTheFieldToTheForm(true);
				}else{
					this.sendDataToForm(this.selectedOptions);
					this.giveError();
					this.sendValidityOfTheFieldToTheForm(false);
				}
			},

		},
		watch:{
			/* If locale change, must reload the list to take lang into account */
			'$store.getters.getLocale': function(){
				this.requestNewListFromAPI();
			},
		},
		mounted(){
			this.requestNewListFromAPI();
		}
	}
</script>

<!-- ================================================================================== -->


<style lang="scss" scoped>
</style>